import React from "react";
import PageLayout from "../components/PageLayout";
import SearchHeader from "../components/SearchHeader";
import Settings from "../components/settings/Settings";
import { useSettings } from "../context/SettingsContext";

const SettingsPage = () => {
  const {
    generalSettings,
    notificationSettings,
    securitySettings,
    setGeneralSettings,
    setNotificationSettings,
    setSecuritySettings,
  } = useSettings();

  return (
    <PageLayout>
      <SearchHeader />
      <div className="inner-main-content">
        <Settings
          generalSettings={generalSettings}
          setGeneralSettings={setGeneralSettings}
          notificationSettings={notificationSettings}
          setNotificationSettings={setNotificationSettings}
          securitySettings={securitySettings}
          setSecuritySettings={setSecuritySettings}
        />
      </div>
    </PageLayout>
  );
};

export default SettingsPage;
